<template>
  <svg aria-label="TruckTrust" viewBox="0 0 284 284" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M228.1 0H55.3C24.8 0 0 24.8 0 55.3v172.8c0 30.5 24.8 55.3 55.3 55.3h172.8c30.5 0 55.3-24.8 55.3-55.3V55.3c0-30.5-24.8-55.3-55.3-55.3Z"
      fill="#E6FFF5"
    />
    <path
      d="M43.6 104.4H129c-17.2 0-31.2 13.9-31.2 31.2v82.3H134V68.2H79.8c-20 0-36.2 16.2-36.2 36.2ZM149.5 68.2v149.7h36.2v-82.3c0-17.2-14-31.2-31.2-31.2h85.4c0-20-16.2-36.2-36.2-36.2h-54.2ZM61.7 219.7c9.941 0 18-8.059 18-18s-8.059-18-18-18c-9.94 0-18 8.059-18 18s8.06 18 18 18ZM221.7 219.7c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18Z"
      fill="#374650"
    />
  </svg>
</template>
